import { render, staticRenderFns } from "./RecursiveComponent.vue?vue&type=template&id=bdf02a34&scoped=true&"
import script from "./RecursiveComponent.vue?vue&type=script&lang=js&"
export * from "./RecursiveComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveComponent.vue?vue&type=style&index=0&id=bdf02a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf02a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VDivider,VRow,VTextField,VTextarea})
